import { apiSlice } from 'state/slices/apiSlice';
const AUTH_URL = '/auth';

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/login`,
                method: 'POST',
                body: data,
            }),
            extraOptions: { skipAuthLogout: true }
        }),
        requestOTP: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/request-otp`,
                method: 'POST',
                body: data,
            }),
            extraOptions: { skipAuthLogout: true }
        }),
        verifyOTP: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/verify-otp`,
                method: 'POST',
                body: data,
            }),
            extraOptions: { skipAuthLogout: true }
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${AUTH_URL}/logout`,
                method: 'POST',
            }),
        }),
        register: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/register`,
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useRequestOTPMutation,
    useVerifyOTPMutation,
    useLogoutMutation,
    useRegisterMutation,
} = authApiSlice;